import FormDialog from "controls/FormDialog";
import { useActionFragment } from "hooks/useAction";
import { Plus } from "mdi-material-ui";
import React from "react";

import LiveStreamCustomOutputsForm from "./Form";

AddLiveStreamDialog.useButtonProps = () => {
  return {
    icon: <Plus />,
    content: "Add Live Stream",
  };
};

export default function AddLiveStreamDialog({ orgId = null, onSubmit, onClose }) {
  const addLiveStream = useActionFragment("addLiveStream", "liveStream { id }");

  return (
    <FormDialog
      header="Add Live Stream"
      onClose={onClose}
      onSubmit={async (formData) => {
        const result = await addLiveStream({
          input: formData,
        });
        await onSubmit?.(result.addLiveStream.liveStream);
      }}
    >
      <LiveStreamCustomOutputsForm
        liveStreams={[
          {
            org: orgId && { id: orgId, __typename: "Org" },
          },
        ]}
      />
    </FormDialog>
  );
}
